// Auto-generated skeleton for Journal

import { AccountingYear } from "./AccountingYear";
import { Document } from "./Document";

export const Journal: Api.Journal = {
  id: 0,
  hp_id: null,
  primanota: 0,
  accounting_year_id: 0,
  account_id: 0,
  booking_date: '',
  booking_text: '',
  contra_account_id: 0,
  opening_balance: 0,
  debit: 0,
  debit_vat: 0,
  credit: 0,
  credit_vat: 0,
  cancellation: false,
  general_ledger: false,
  document_container_id: 0,
  comments_count: 0,
  comments: [],
  accounting_year: AccountingYear,
  account: null,
  contra_account: null,
  receipt: Document,
  reviews: [],
  review_state: 'DENIED',
  created: null,
  updated: null,
};

